// GamesFolder/TreeGames/TreeGame.js
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getStackGame = (subcategory, stage) => {
    if (subcategory === "Array-based Stack") {
        switch (stage.name.toLowerCase()) {

            case "functions":
                return <AllGames.ArrayBasedFunctionStackGame />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
